import { render, staticRenderFns } from "./WhatsAppMessageTemplateHeader.vue?vue&type=template&id=77fedb36&scoped=true&"
import script from "./WhatsAppMessageTemplateHeader.vue?vue&type=script&lang=js&"
export * from "./WhatsAppMessageTemplateHeader.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppMessageTemplateHeader.vue?vue&type=style&index=0&id=77fedb36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fedb36",
  null
  
)

export default component.exports